import queryString from 'query-string';
import config from '../../../config';
import { getConfigValue } from './ConfigsApi';

export const getFreeShippingTierEligibility = async (productConfigs) => {
    const queryParams = queryString.stringify({ productConfigs }, { arrayFormat: 'bracket' });
    const storeCode = config.storeCode;

    return $.ajax({
      method: 'GET',
      url: `${config.shipping}/free-shipping-tier/${storeCode}?${queryParams}`
    });
}

export const showPdpFreeShippingTierBadge = async () => {
    const configKey = 'show-pdp-fst-badge';

    const configValue = await getConfigValue(configKey);
    return configValue.length > 0 && configValue[0].toLowerCase() === 'on' || false;
}



// WEBPACK FOOTER //
// ./src/Common/Providers/FreeShippingTierApi.js